import type { ReactNode } from 'react'
import Header from 'layout/Header'
import Footer from 'layout/Footer'

type Props = {
  children: ReactNode
}

export default function Layout({ children }: Props) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  )
}
